import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { default as NextLink } from 'next/link';
import { UrlObject } from 'url';
import { SearchOptionsParams } from 'models/SearchOptionsParams';
import { SearchOptions as SearchOptionsStyled } from './SearchOptions.styles';
import { buildHref } from 'helpers/buildHref';
import { Icon } from '@trustedshops/tps-seo-shared-frontend-react-components';
import { iconVariables } from 'styles/icon.variables';
const { domain } = require('helpers/constants');

const SearchOptions: FunctionComponent<SearchOptionsParams> = ({
  activeFilters
}: SearchOptionsParams) => {
  const { locale, formatMessage } = useIntl();

  const countries = ['DE', 'AT', 'CH'].filter(
    (country) => !locale.endsWith(country)
  );
  const subdomain = 'www';

  return (
    <SearchOptionsStyled>
      {countries.map((country) => {
        const topLevelDomain = country.toLowerCase();
        const host = `${subdomain}.${domain}.${topLevelDomain}`;

        const href: UrlObject = {
          ...buildHref({
            q: activeFilters.q,
            category: activeFilters.category,
            embed: activeFilters.embed
          }),
          host,
          protocol: 'https'
        };
        return (
          <NextLink
            href={href}
            key={country}
            rel="nofollow"
            target="_blank"
            className="extension"
            id={`extension-${country}`}
          >
            {formatMessage(
              {
                id: 'RESULT_LIST.NO_RESULTS.INTERNATIONAL_SEARCH.RESULTS_FROM'
              },
              { country: formatMessage({ id: `COUNTRIES.${country}` }) }
            )}
            <Icon
              iconName={'icon-arrow-chevron-right'}
              iconSize={iconVariables.SIZE_S}
              lineHeight={iconVariables.LINE_HEIGHT_REGULAR}
            />
          </NextLink>
        );
      })}
    </SearchOptionsStyled>
  );
};

export default SearchOptions;
